// eslint-disable-next-line no-shadow
enum ETipoTermosAceiteOnboarding {
  TERMOS_DE_USO = 1,
  TERMOS_DE_PRIVACIDADE = 2,
}

export default ETipoTermosAceiteOnboarding
